import fe, { info } from "@randajan/simple-app/fe";
import jet from "@randajan/jet-core";

import { screen } from "@randajan/jet-react/base/screen";
import { page } from "@randajan/jet-react/base/page";

page.setLock("title", "itcan");

screen.config({
    widths:[480, 600, 960, 1280, 1920],
    heights:[300, 600, 920, 1280]
});

// if (!info.isProd) {
//     Object.assign(window, {
//         jet,
//         base:{
//             page, screen
//         }
//     });
// }

export {
    screen,
    page
}